import loadable from '@loadable/component';

export const ProductTabStatistics = loadable(
  () =>
    import(
      /* webpackChunkName: "product-tab-statistics" */ '../../../product-price-history'
    )
);
